import { INewsState } from "@/core/interfaces/news.interface";

const state: INewsState = {
  isNewsLoading: false,
  news: null,
};

export default state;
